import { Component, Input } from '@angular/core';
import { NgFor, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { BaseCreatingEditing } from '../../../shared-classes/BaseCreatingEditing';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { NbCardModule, NbPopoverModule, NbInputModule, NbDatepickerModule, NbSelectModule, NbOptionModule, NbIconModule, NbButtonModule, NbSpinnerModule } from '@nebular/theme';
import { NgLetModule } from 'ng-let';
import { entryProp } from '../../../interfaces/apiCalls';
import { StatusIconDirective } from '../../../directives/status-icon.directive';

@Component({
  selector: 'app-standard-input',
  standalone: true,
  templateUrl: './standard-input.component.html',
  styleUrls: ['./standard-input.component.scss'],
  imports: [NgIf, NbCardModule, FormsModule, ReactiveFormsModule, NgFor, NbPopoverModule, NgSwitch, NgSwitchCase, NbInputModule, NbDatepickerModule, NbSelectModule, NbOptionModule, NgSwitchDefault, NbIconModule, NbButtonModule, MatRippleModule, NbSpinnerModule, NbDateFnsDateModule, NgLetModule, StatusIconDirective]
})
export class StandardInputComponent {

  @Input('parentRef') parent: BaseCreatingEditing;
  @Input() field : entryProp ; // this is the form field ref, it is passed here from a template variable of the parent component and is not defined on the parent component itself !
}
